module.exports = __webpack_public_path__ + "img/settings.00e13479.svg";